import { render, staticRenderFns } from "./FiltroServidor.vue?vue&type=template&id=2b32411d"
import script from "./FiltroServidor.vue?vue&type=script&lang=js"
export * from "./FiltroServidor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports